import createPlugin from './pm-plugins/main';
import { processCopyButtonItems } from './ui/toolbar';
export var copyButtonPlugin = function copyButtonPlugin(_ref) {
  var _api$analytics;
  var api = _ref.api;
  return {
    name: 'copyButton',
    pmPlugins: function pmPlugins() {
      return [{
        name: 'copyButton',
        plugin: function plugin() {
          return createPlugin();
        }
      }];
    },
    actions: {
      processCopyButtonItems: processCopyButtonItems(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions)
    }
  };
};